import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-history-replace-confirm-modal',
  templateUrl: './history-replace-confirm-modal.component.html',
  styleUrls: ['./history-replace-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HistoryReplaceConfirmModalComponent {
  @Input() changeSummary: Array<{ label: string; value: string }> = [];
  /** Controls which title / body copy is shown. */
  @Input() mode: 'replace' | 'delete' = 'replace';

  constructor(public activeModal: NgbActiveModal) {}

  confirm(): void {
    this.activeModal.close(true);
  }
}
